import BaseService from '@/scripts/services/base.service';
import CommonHelper from '../helpers/common.helper';
import { loadScript } from '@/scripts/helpers/scriptLoader.helper';

import axios from 'axios'

const PAGARME_SCRIPT_URL = 'https://assets.pagar.me/pagarme-js/4.5/pagarme.min.js';

export default class PagarMeService extends BaseService {

  constructor(pagarMe) {
    super('PagarMe');
    this.pagarMe = pagarMe;
    this.encryptionKey = process.env.VUE_APP_PAGARME_ENCRYPTION_KEY;
    this.publicEncryptionKey = process.env.VUE_APP_PAGARME_PUBLIC_ENCRYPTION_KEY;
  }

  async ensurePagarMeLoaded() {
    if (typeof window.pagarme === 'undefined') {
      await loadScript(PAGARME_SCRIPT_URL);
    }
  }

  prepareSenderHash(checkoutRequest) {
    return this.ensurePagarMeLoaded().then(() => {
      return new Promise(function (resolve, reject) {

        const card =  {
          card_holder_name: checkoutRequest.creditCardInfo.holder.name,
          card_number: checkoutRequest.creditCardInfo.cardNumber,
          card_expiration_date: `${checkoutRequest.creditCardInfo.expirationMonth}/${checkoutRequest.creditCardInfo.expirationYear.substr(2,2)}`,
          card_cvv: checkoutRequest.creditCardInfo.cvv
        };

        pagarme.client.connect({ encryption_key: this.encryptionKey })
            .then(client => client.security.encrypt(card))
            .then(card_hash => {
              checkoutRequest.paymentSenderInfo.hash = card_hash;
              checkoutRequest.creditCardInfo.token = card_hash;
              resolve(checkoutRequest);
            })
      }.bind(this));
    });
  }

  getCardBrand(checkoutRequest) {
    console.log(checkoutRequest);
    return new Promise(function (resolve, reject) {
      this.pagarMeDirectPayment.getBrand({
        cardBin: checkoutRequest.creditCardInfo.cardNumber.slice(0, 6),
        success: function (response) {
          checkoutRequest.creditCardInfo.brand = response.brand.name;
          resolve(checkoutRequest);
        }.bind(this),
        error: function (response) {
          reject(response);
        }.bind(this)
      });
    }.bind(this));
  }

  createCardToken(checkoutRequest) {
    return new Promise(function (resolve, reject) {
      this.pagarMeDirectPayment.createCardToken(
        Object.assign(checkoutRequest.creditCardInfo, {
          success: function (response) {
            checkoutRequest.creditCardInfo.token = response.card.token;
            resolve(checkoutRequest);
          }.bind(this),
          error: function (response) {
            reject(response);
          }.bind(this)
        })
      );
    }.bind(this));
  }


  // createTransaction(card) {
  //   return this.postRequest('createTransaction', card);
  // }

  createPreApproval(card) {
    return this.postRequest('createPreApproval', card);
  }

  createTransaction(hash, token) {
    return this.postRequest('CreateTransaction', {
      hash: hash,
      creditCardToken: token
    });
  }

  prepareCreditCardCheckout(checkoutRequest) {
    return this.prepareSenderHash(checkoutRequest)
      .catch(function(response){
        console.log(response);

        CommonHelper.swal('','Ops, por favor, certifique-se de que as informações do seu cartão crédito estão corretas.','error');

        throw response;
      });
    // return this.postRequest('CreateSubscription', {
    //   hash: hash,
    //   creditCardToken: token
    // });
  }

  tokenizerCard(card) {
    // delete axios.defaults.headers
    // console.log(axios.defaults.headers)
    return axios({
      url: `https://api.pagar.me/core/v5/tokens?appId=${this.publicEncryptionKey}`,
      method: 'POST',
      data: card,
      transformRequest: [(data, headers) => {
        delete headers.common;
        if (data) headers['Content-Type'] = 'application/json';
        return JSON.stringify(data)
      }],
    });
  }
}